var sphereWebGLStatic = {
	tail: [],
	stereoEnabled: false,

	postRender: function() {
		if (sphereWebGLStatic.renderer != undefined) sphereWebGLStatic.renderer.clearDepth();
	},

	stereoScreen: function(b) {
		sphereWebGLStatic.stereoEnabled = b;
		if (!b) {
			sphereWebGLStatic.renderer.setSize( sphereWebGLStatic.node.width(), sphereWebGLStatic.node.height());
			//$(".overlay").hide();
			//$(".nav").hide();
			//$("#wcag-cnt").hide();
			//$("#menu_container").hide();
			$("#ui").show();
			$("#panels").show();
			HotSpotManager.setVisibility(true);
			FullScreen.toggle();
		} else {
			$("#ui").hide();
			$("#panels").hide();
			HotSpotManager.setVisibility(false);

			setTimeout(function() {
				$("body").one("click", function() {
					sphereWebGLStatic.stereoScreen(false);
				});
			}, 500);
			//$(".overlay").show();
			//$(".nav").show();
			//$("#wcag-cnt").show();
			//$("#menu_container").show();
		}
		FullScreen.toggle();
		Gyroscope.startStop();
	},

	toggleStereo: function() {
		sphereWebGLStatic.stereoScreen(!sphereWebGLStatic.stereoEnabled);
	}
};

function sphereWebGLRenderer(id,props, half) {
	this.ident = id;
	this.properties = props;
	this.node = null;
	this.ql = 1;
	sphereWebGLStatic.self = this;
	this.fov = 0;
	this.textures = [];
	this.fragments = {};
	this.worker = null;
	this.opacity = 0;
	this.fading_in = 0;
	this.fading_out = 0;
	this.preview = null;
	this.disort = {"x":0, "y":0, "dstx":0, "dsty":0};
	this.transCounter = 1;
	this.transSpeed = 0;
	this.panofile = "";
	this.cycle = "";
	this.showLoading = true;
	this.opacityStep = 0.04;

	if (player.lastView != undefined && player.lastView != null && player.lastView.renderer != undefined && player.lastView.renderer != null && player.lastView.renderer.disort != undefined) {
		this.disort = player.lastView.renderer.disort;
	}

	sphereWebGLStatic.ident = id;

	var self = this;

	this.worker = setInterval(function() {
						self.loadFrustum();
					}, 100);

}

sphereWebGLRenderer.prototype = {
	rx: 0,
	ry: 0,
	veryHighQualityLoaded:false,
	basePerspective: 550, //tak jak perspective w css
	zoom:550, // 500 zoom powinno byc rowne perspective w css
	
	loadTemplate: function() {
		if ($("#c3d") == undefined || $("#c3d").length == 0) {
			//$("#player").html(TPL.render("panorama-template", {"w":this.planeWidth, "wfix":this.wfix, "wfixname":this.wfixname}));
			$("#player").append("<div id='c3d' style='width:100%;height:100%;position:absolute;z-index:999;'></div>")
			sphereWebGLStatic.fresh = true;
			sphereWebGLStatic.node = $("#c3d");
		}

		this.node = $("#c3d");

	},

	reUse: function() {
	},

	build: function() {
		
		if (sphereWebGLStatic.fresh) {
			sphereWebGLStatic.cycle = 0;
			sphereWebGLStatic.scene = new THREE.Scene();
			//sphereWebGLStatic.camera = new THREE.PerspectiveCamera( 45, sphereWebGLStatic.node.width() / sphereWebGLStatic.node.height(), 0.1, 1000 );

			sphereWebGLStatic.renderer = new THREE.WebGLRenderer({ preserveDrawingBuffer: true, alpha: true });
//			sphereWebGLStatic.renderer = new THREE.WebGLRenderer({ preserveDrawingBuffer: false, alpha: true });
			sphereWebGLStatic.renderer.autoClear = false;
//			sphereWebGLStatic.renderer.autoClear = true;
			sphereWebGLStatic.renderer.xr.enabled = true;
			sphereWebGLStatic.renderer.xr.cameraAutoUpdate = false;
			sphereWebGLStatic.renderer.xr.setReferenceSpaceType( 'local' );

			sphereWebGLStatic.renderer.setSize( sphereWebGLStatic.node.width(), sphereWebGLStatic.node.height());
			sphereWebGLStatic.node.append($(sphereWebGLStatic.renderer.domElement));

			sphereWebGLStatic.fresh = false;

			try {
				if (StereoEffect != undefined) sphereWebGLStatic.stereo = new StereoEffect(sphereWebGLStatic.renderer);
			} catch(e) {

			}

			sphereWebGLStatic.self.cup = new THREE.Vector3(0,1,0);

		} else {
			sphereWebGLStatic.cycle = sphereWebGLStatic.cycle == 0 ? 1 : 0;
		}

		this.scene = sphereWebGLStatic.scene;
		this.camera = new THREE.PerspectiveCamera( 45, sphereWebGLStatic.node.width() / sphereWebGLStatic.node.height(), 0.1, 1000 ); //sphereWebGLStatic.camera;
		this.vrcamera = new THREE.PerspectiveCamera( 45, sphereWebGLStatic.node.width() / sphereWebGLStatic.node.height(), 0.1, 1000 ); //sphereWebGLStatic.camera;
		this.camera.layers.set(sphereWebGLStatic.cycle);
		this.vrcamera.layers.set(sphereWebGLStatic.cycle);
		this.cycle = sphereWebGLStatic.cycle;
//		this.camera.translateZ(50);
//		this.camera = sphereWebGLStatic.camera;

		if (StereoEffect != undefined) sphereWebGLStatic.stereo.setCycle(sphereWebGLStatic.cycle);

		this.renderer = sphereWebGLStatic.renderer;
	},

  	realZoom: function() {
  		return this.zoom;
  	},

  	setPerspective: function(v, tmp) {
  		//this.minZoom = v;
  		this.zoom = v;

		//this.zoom -= 250;

		this.basePerspective = this.zoom;
		if (tmp != undefined) this.basePerspective *= tmp;

		//var persp = Math.pow( this.node.width()/2 * this.node.width()/2 + this.node.height()/2 * this.node.height()/2, 0.5 ) / Math.tan( 30 * Math.PI / 180 )
		var distance = this.basePerspective;
		this.fov = 2 * (Math.atan((this.node.height() * 0.5) / distance) * 180 / Math.PI);

		this.camera.aspect = sphereWebGLStatic.node.width() / sphereWebGLStatic.node.height();

		this.camera.fov = this.fov;
		this.camera.updateProjectionMatrix();

		this.vrcamera.aspect = sphereWebGLStatic.node.width() / sphereWebGLStatic.node.height();

		this.vrcamera.fov = this.fov;
		this.vrcamera.updateProjectionMatrix();

		sphereWebGLStatic.renderer.setSize( sphereWebGLStatic.node.width(), sphereWebGLStatic.node.height() );
  	},

  	getPerspective: function() {
  		return this.basePerspective;
  	},

  	loadSphere: function(w, h) {
  		this.ql = 1;

  		switch(Quality.current) {
  			case 1280:
  				this.ql = 0.5;
  			break;
  			case 2048:
  			break;
  		}

  		var texSize = 500 * this.ql;
		//http://p3.wkraj.pl/proxify/thumbpano/noredirect/true/file/-pdata-70460_lpan.jpg/sx/1/clip/5500,2000,500,500/piece.jpg

		if (player.offline) {
			this.panofile = "data/pano_" + this.properties.place_id + "_preview.jpg";
		} else {
			this.panofile = this.properties.properties.image1;
		}

		if (this.properties.variants != undefined) {
			if (this.properties.variants.variant_main == player.variant) {
				if (player.offline) {
					this.panofile = "data/pano_" + this.properties.place_id + "_preview.jpg";
					console.log('variant_main: ' + this.panofile);
				} else {
					this.panofile = this.properties.properties.image1;
				}
			} else if (this.properties.variants.items != undefined) {
				for(var n in this.properties.variants.items) {
					if (this.properties.variants.items[n].type == player.variant) {
						if (player.offline) {
							this.panofile = "data/pano_" + this.properties.place_id + "_" + player.variant + "_preview.jpg";
						} else {
							this.panofile = this.properties.variants.items[n].file;
						}
					}
				}
			}
		}

		if (this.properties.properties.l_width == 12000) {
			texSize = 1000 * this.ql;
			//texSize = 500
		}


		var hcount = w / texSize;
		var vcount = h / texSize;
		
		var no = 0;
		var tex = null;

		var self = this;
//		tex = new THREE.TextureLoader().load( "http://" + PROJECT.domain + ".wkraj.pl/proxify/thumbpano/noredirect/true/file/-pdata-" + this.properties.place_id + "_lpan.jpg/sx/1/clip/0,0,500,500/piece.jpg");
		if (this.showLoading) player.preload(true);

		var previewUrl = "";
		if (player.offline) {
			previewUrl = this.panofile;
		} else {
			previewUrl = "//" + PROJECT.host + "/proxify/thumbpano/noredirect/true/file/-pdata-" + this.panofile + "/preview.jpg";
		}

		tex = new THREE.TextureLoader().load( previewUrl, function(preview) {
//			HotSpotManager.setVisibility(true);
			
			AppEvent.trigger(player, "PLACE.LOADED", sphereWebGLStatic.self);

//			self.preview.layers.set(sphereWebGLStatic.cycle);

			for(var y = 0; y < vcount; y ++) {
				for(var x = 0; x < hcount; x ++) {

					var sx = (x * (360 / hcount)) * Math.PI / 180;
					var ex = (360 / hcount) * Math.PI / 180;
					var sy = (y * (180 / vcount)) * Math.PI / 180;
					var ey = (180 / vcount) * Math.PI / 180;

//					var geometry = new THREE.InnerSphereGeometry( 25, 8, 8, sx, ex, sy, ey);
					var geometry = new InnerSphereGeometry( 25, 8, 8, sx, ex, sy, ey);
					var material;
					/*
					if ((x + y) % 2 == 1) material = new THREE.MeshBasicMaterial( {color: 0xaaaaaa} );
					if ((x + y) % 2 == 0) material = new THREE.MeshBasicMaterial( {color: 0x666666} );
					*/
					material = new THREE.MeshBasicMaterial( {color: 0x666666, opacity:0, transparent:true} );
	//				var material = new THREE.MeshBasicMaterial( {color: 0xffffff, map: tex} );
					material.side = THREE.DoubleSide;

					var fragment = new THREE.Mesh( geometry.getMesh(), material );
					//this.geometry = sphere;
					fragment.layers.set(sphereWebGLStatic.cycle);
					self.preview.add( fragment );

					if (self.ql == 1) self.fragments[no] = {"mesh": fragment, "textureLoaded": false, "x": ((w - texSize) - (x * texSize)), "y": (y * texSize)};

					//this.textures.push(tex);
					no ++;
				}
			}
			
			self.fading_in = 1;
			if (self.showLoading) player.preload(false);

			if (panoramaViewStatic.root != undefined) panoramaViewStatic.root.loaded();
		});
	
		this.previewTexture = tex;
		//tex.generateMipmaps = false;
		
//		var geometry = new THREE.InnerSphereGeometry( 25.2, 38, 22);
		var geometry = new InnerSphereGeometry( 25.2, 38, 22);
		var material;
		material = new THREE.MeshBasicMaterial( {color: 0xffffff, map: tex} );
		material.side = THREE.DoubleSide;
		material.opacity = 0;
		material.transparent = true;
		material.needsUpdate = true;

		this.preview = new THREE.Mesh( geometry.getMesh(), material );
		//this.preview.position.x = 0;
		//this.preview.position.y = 0;
		//this.preview.position.z = -88;
		this.preview.layers.set(sphereWebGLStatic.cycle);
		this.scene.add( this.preview );
		
		var excl = window.PROJECT.settings['core/panologo/exclude'];
		var exclude = false;

		if (excl != undefined) {
			var ids = excl.split(",");
			for(var n in ids) {
				if (ids[n] == this.ident) exclude = true;
			}
		}

		if (!exclude && window.PROJECT.settings['core/panologo'] != undefined && window.PROJECT.settings['core/panologo'] != "") {
			var ltex = new THREE.TextureLoader().load( "https://" + window.PROJECT.host + "/" + window.PROJECT.settings['core/panologo'], function(lt) {

				var scale = 9;

				if (window.PROJECT.settings['core/panologo_size'] != undefined) {
					scale = parseFloat(window.PROJECT.settings['core/panologo_size']) * 9;
				}

				const logoMaterial = new THREE.MeshBasicMaterial( {color: 0xffffff, side: THREE.DoubleSide, map:ltex} );
//				const logoPlateGeom = new THREE.PlaneGeometry( 20, 20, 5, 5 );
				const logoPlateGeom = new THREE.CircleGeometry( scale, 64 );
				sphereWebGLStatic.self.logoPlate = new THREE.Mesh( logoPlateGeom, logoMaterial );		
		//		sphereWebGLStatic.self.logoPlate.translateZ(-24);
				sphereWebGLStatic.self.logoPlate.translateY(-20);
//				sphereWebGLStatic.self.logoPlate.translateY(-23);
				sphereWebGLStatic.self.logoPlate.rotateX(-90 * Math.PI / 180);
				sphereWebGLStatic.self.logoPlate.layers.set(sphereWebGLStatic.cycle);
				sphereWebGLStatic.self.preview.add( sphereWebGLStatic.self.logoPlate );
			});
		}
		//console.log(sphereWebGLStatic.cycle);
  	},

  	loadFragmentTexture: function(no) {
  		var bw = 500 * this.ql;
  		var bh = 500 * this.ql;
  		var sx = 1;
  		var sy = 1;

  		if (player._width < 1100) {
  			sx = 0.5;
  			sy = 0.5;
  		}

  		if (this.properties.properties.l_width == 12000) {
  			bw = 1000 * this.ql;
  			bh = 1000 * this.ql;
  			sx = 1; //0.5;
  			sy = 1; //0.5;

  			sx = 0.75;
  			sy = 0.75;

  			/*
	  		if (player._width < 1100) {
	  			sx = 0.25;
	  			sy = 0.25;
	  			if (window.devicePixelRatio && window.devicePixelRatio > 1) {
		  			sx = 0.5;
		  			sy = 0.5;	  				
	  			}
	  		} else if (player._width < 1700) {
	  			sx = 0.5;
	  			sy = 0.5;
	  		} else if (player._width < 1921) {
	  			sx = 0.75;
	  			sy = 0.75;
	  		}
	  		*/
  		}

  		var url = "";
  		var self = this;

		if (player.offline) {
			if (player.variant != undefined && player.variant != null && player.variant != "" && this.properties.variants.variant_main != player.variant)
				url = "data/frag_" + this.properties.place_id + "_" + player.variant + "_" + this.fragments[no].x + "_" + this.fragments[no].y + "_1.jpg";
			else
				url = "data/frag_" + this.properties.place_id + "_" + this.fragments[no].x + "_" + this.fragments[no].y + "_1.jpg";

		} else {
			url = "//" + PROJECT.host + "/proxify/thumbpano/noredirect/true/file/-pdata-" + this.panofile + "/sx/" + sx + "/sy/" + sy + "/clip/" + this.fragments[no].x + "," + this.fragments[no].y + "," + bw + "," + bh + "/piece.jpg";
		}

//  		setTimeout(function() {
		
			tex = new THREE.TextureLoader().load(url, function(texture) {				
				//texture.magFilter = THREE.NearestFilter;
				//texture.minFilter = THREE.NearestFilter;
				texture.magFilter = THREE.LinearFilter;
				texture.minFilter = THREE.LinearFilter;
				//texture.minFilter = THREE.NearestMipMapLinearFilter;
				//texture.generateMipmaps = false;
				//texture.anisotropy = 16;
				//texture.generateMipmaps = true;

				self.fragments[no].mesh.material.color.setHex(0xffffff);
				self.fragments[no].mesh.material.opacity = 0;
				self.fragments[no].texture = texture;
				self.fragments[no].mesh.material.map = texture;
				self.fragments[no].mesh.material.needsUpdate = true;
				self.fragments[no].textureLoaded = true;
			});		

//		}, Math.round(Math.random() * 30));
  	},

  	inFrustum: function() {
  		var found = [];

		this.camera.updateMatrix(); // make sure camera's local matrix is updated
		this.camera.updateMatrixWorld(); // make sure camera's world matrix is updated

		if (this.camera.matrixWorldInverse.getInverse != undefined)
			this.camera.matrixWorldInverse.getInverse( this.camera.matrixWorld );
		else {
			this.camera.matrixWorldInverse.copy( this.camera.matrixWorld );
			this.camera.matrixWorldInverse.invert();
		}

		var frustum = new THREE.Frustum();
		if (frustum.setFromMatrix != undefined) {
			frustum.setFromMatrix( new THREE.Matrix4().multiplyMatrices( this.camera.projectionMatrix, this.camera.matrixWorldInverse ) );
		} else {
			frustum.setFromProjectionMatrix( new THREE.Matrix4().multiplyMatrices( this.camera.projectionMatrix, this.camera.matrixWorldInverse ) );
		}

		for(var no in this.fragments) {
			var fragment = this.fragments[no].mesh;
			fragment.updateMatrix(); // make sure plane's local matrix is updated
			fragment.updateMatrixWorld(); // make sure plane's world matrix is updated

			if (frustum.intersectsObject(fragment)) {
				found.push(no);
			}

		}
		return found;
  	},

  	loadFrustum: function() {
  		var nos = this.inFrustum();
  		var fragment = null;

  		var half = Math.floor(nos.length / 2);

  		for(var n = 0; n <= half; n ++) {
  			if (half - n >= 0) {
	  			fragment = this.fragments[nos[half - n]];
	  			if (fragment != undefined && !fragment.textureLoaded) {
	  				this.loadFragmentTexture(nos[half - n]);
	  			}
  			}

  			if (half + n < nos.length) {
	  			fragment = this.fragments[nos[half + n + 1]];
	  			if (fragment != undefined && !fragment.textureLoaded) {
	  				this.loadFragmentTexture(nos[half + n + 1]);
	  			}
  			}
  		}

  	},

	load: function() {
//		player.preload(true);
		
		/*
		var texture = new THREE.TextureLoader().load( "/data/" + this.properties.properties.image1 );
		texture.magFilter = THREE.NearestFilter;
		texture.minFilter = THREE.NearestFilter;
		*/

//		var geometry = new THREE.InnerSphereGeometry( 25, 42, 42, 0, (180 * Math.PI / 180), 0, (90 * Math.PI / 180));

		/*
		var geometry = new THREE.InnerSphereGeometry( 25, 42, 42);
		var material = new THREE.MeshBasicMaterial( {color: 0xffffff, map: texture} );
		material.side = THREE.DoubleSide;

		var sphere = new THREE.Mesh( geometry, material );
		this.geometry = sphere;
		this.scene.add( sphere );
		*/

		if (this.properties.properties.l_width != 12000)
			this.loadSphere(8000, 4000);
		else
			this.loadSphere(12000, 6000);

		this.setPerspective(650);

	},
	
	loadQuality: function(q) {
	},
	
	checkLoaded: function() {		
	},

	process: function() {
		var self = this;

		//console.log(player._mouseHoverX);

		if (player._mouseHoverX != undefined) this.disort.dstx = (player._mouseHoverX - (player._width * 0.5)) * 0.005;
		if (player._mouseHoverY != undefined) this.disort.dsty = (player._mouseHoverY - (player._height * 0.5)) * -0.005;

		
		if (player.cms) {
			this.disort.x = 0;
			this.disort.y = 0;
		} else {
			this.disort.x += (this.disort.dstx - this.disort.x) * 0.1;
			this.disort.y += (this.disort.dsty - this.disort.y) * 0.1;
		}

		/*
		this.disort.x = 0;
		this.disort.y = 0;
		*/
		
		var sx = this.disort.x;
		var sy = this.disort.y;

		//this.jaw = -(this.rx - 90) * Math.PI / 180;// * -0.015;
		this.jaw = (this.rx + sx) * Math.PI / 180;// * -0.015;
		this.pitch = (-this.ry - sy) * Math.PI / 180;// * -0.015;

		sphereWebGLStatic.self.cup = new THREE.Vector3(0, 1, 0);
		sphereWebGLStatic.self.cup.applyAxisAngle(new THREE.Vector3(1,0,0), this.pitch);

		//console.log(Math.round(this.jaw * 180 / Math.PI));
		
		//console.log(Math.round(this.jaw * 180 / Math.PI) + " , " + Math.round(this.pitch * 180 / Math.PI));

		var xx = Math.cos(this.jaw * Math.PI / 180) * 1;
		var zz = Math.sin(this.jaw * Math.PI / 180) * 1;
		var yy = Math.sin(this.pitch * Math.PI / 180) * 1;
		var zz2 = Math.sin(this.pitch * Math.PI / 180) * 1;

		var lv = new THREE.Vector3(0, 0, 1);

		var mtx = new THREE.Matrix4();
		mtx.makeRotationX( this.pitch );

		var mtx2 = new THREE.Matrix4();
		mtx2.makeRotationY( this.jaw );

		mtx2.multiply(mtx);

		lv.applyMatrix4(mtx2);

		//this.preview.look(lv);

		//this.preview.matrix.set(mtx2);
		if (this.preview) this.preview.rotation.x = this.pitch;
		if (this.preview) this.preview.rotation.y = ((this.rx + sx) + 90) * Math.PI / 180;

		if (this.logoPlate) {
			this.logoPlate.rotation.z = -1 * ((this.rx + sx) + 90) * Math.PI / 180;
		}

		this.fade();

	 	//this.camera.lookAt(lv);

	 	//this.camera.translateX(0.3);

	 	if (!sphereWebGLStatic.stereoEnabled)
			this.renderer.render( this.scene, this.camera, undefined, false);
		else 
			sphereWebGLStatic.stereo.render(this.scene, this.camera);

		//this.renderer.clearDepth();
		/*
		if (sphereWebGLStatic.previous != null && sphereWebGLStatic.previous != undefined) {
			sphereWebGLStatic.previous.fade();
		}
		*/
	},

	vrLoop: function() {
		sphereWebGLStatic.renderer.setAnimationLoop(this.vrRender.bind(this));
	},

	vrEnable: function() {
		document.body.appendChild( VRButton.createButton( sphereWebGLStatic.renderer ) );
		this.vrLoop();
	},

	vrRender: function() {
		if (this.renderer.xr.isPresenting) {
			this.renderer.xr.updateCamera(this.vrcamera);		
			this.preview.rotation.x = 0;
			this.preview.rotation.y = 0;
			this.renderer.render( this.scene, this.vrcamera, undefined, false);
		}
	},

	clear: function() {
		clearInterval(this.worker);
	},

	beforeLeave: function() {				
		player.lastView = null;	
		
		this.fading_in = 0;
		this.fading_out = 1;
		this.transCounter = 0;
		this.transSpeed = 0;
		this.preview.scale.set(2, 2, 2);
	},

	leaving: function() {			
	//	console.log("leaving");		
	
		while(sphereWebGLStatic.tail.length > 0) {
			var d = sphereWebGLStatic.tail.shift();
			d.destroy();
		}

		sphereWebGLStatic.tail.push(this);
		sphereWebGLStatic.previous = this;

		this.fading_in = 0;
		this.preview.scale.set(2, 2, 2);
		
		for(var n in this.fragments) {
			//this.fragments[n].mesh.scale.set(1.4, 1.4, 1.2);
		}
		
		self = this;
		/*
		AppEvent.one(player, "PLACE.LOADED", function(data) {
			self.fading = true;
		});
		*/
		if (player.current.place_type != "panorama") {
			this.node.css("z-index", "100");
		}

		AppEvent.one(player, "PLACE.TRANSITIONED", function(evt) {
			//console.log("Destroying " + self.ident);
			//self.destroy();
			//console.log(evt.data)

			//evt.data.me.destroy();
			//console.log("transitioned to " + player.current.place_type);

			// 22.05.2020 - przeniesione z destroy, zeby wyeliminowac czarny ekran przy przejsciu z panoramy na zdjecie
			if (player.current.place_type != "panorama") self.node.remove();

		}, {"me": self});
	},

	destroy: function() {

		this.scene.remove(this.preview);
		//this.preview.dispose();
		this.preview = null;
		this.camera = null;

		this.previewTexture.dispose();
		this.previewTexture = null;

		for(var n in this.fragments) {
			this.scene.remove(this.fragments[n].mesh);
			//this.fragments[n].mesh.dispose();
			this.fragments[n].mesh = null;
			if (this.fragments[n].texture != undefined) {
				this.fragments[n].texture.dispose();
				this.fragments[n].texture = null;
			}
		}		

		//if (player.current.place_type != "panorama") this.node.remove();
	},

	fade: function() {

		var transInLen = 0;
		var transOutLen = 0;

		if (HotSpotManager.currentTransition != undefined) {
			transInLen = HotSpotManager.currentTransition.inzoom;
			transOutLen = HotSpotManager.currentTransition.outzoom;
			/*
			console.log(HotSpotManager.currentTransition.outzoom);
			console.log(HotSpotManager.currentTransition.inzoom);
			*/
		}

		if (this.fading_in != 1 && this.fading_out != 1) {
			
			this.preview.material.opacity = 1;
			this.preview.material.transparent = true;
			this.preview.material.needsUpdate = true;
						
			for(var n in this.fragments) {
				if (this.fragments[n].textureLoaded) {
					this.fragments[n].mesh.material.opacity = 1;
					this.fragments[n].mesh.material.transparent = false;
					this.fragments[n].mesh.material.needsUpdate = true;
				}
			}
			
			if (!this.fading_in && !this.fading_out) return;
		}

		if (this.fading_in && this.preview != null) {
			var jm = 0;
			var pm = 90;

			var dvx = cos((this.jaw + jm) * (Math.PI / 180)) * cos((this.pitch + pm) * (Math.PI / 180));
			var dvy = sin((this.jaw + jm) * (Math.PI / 180)) * cos((this.pitch + pm) * (Math.PI / 180));
			var dvz = sin((this.pitch + pm) * (Math.PI / 180));

//			this.opacity += 0.01;
			this.opacity += this.opacityStep;

			this.transCounter *= (1 - this.opacityStep);// 0.97;//(1 - transInAcc);
//			this.transCounter *= 0.91;//(1 - transInAcc);

			var cc = 1 - this.transCounter;

			if (cc > 0.9999) cc = 1;

			if (cc <= 1) {
				this.preview.position.x = (dvx - (dvx * cc)) * -transInLen;
				this.preview.position.y = (dvy - (dvy * cc)) * -transInLen;
				this.preview.position.z = (dvz - (dvz * cc)) * -transInLen;
			}

			this.preview.material.opacity = this.opacity;
			this.preview.material.transparent = true;
			this.preview.material.needsUpdate = true;

			if (this.fading_in == 1 && this.opacity >= 1) {
				player.freezedisort = undefined;

				this.fading_in = 2;
				//this.fading_in = 0; // poprawic z powrotem na 2 gdy bedziemy wlaczac przejscia ponownie
				AppEvent.trigger(player, "PLACE.TRANSITIONED", sphereWebGLStatic.self);
				HotSpotManager.setVisibility(true);
			}

			if (cc >= 1) {
				this.fading_in = 0;
//				sphereWebGLStatic.previous.destroy();
//				sphereWebGLStatic.previous = null;
			} 
		}

		if (this.fading_out && this.preview != null) {
			var jm = 0;
			var pm = 90;

			var dvx = cos((this.jaw + jm) * (Math.PI / 180)) * cos((this.pitch + pm) * (Math.PI / 180));
			var dvy = sin((this.jaw + jm) * (Math.PI / 180)) * cos((this.pitch + pm) * (Math.PI / 180));
			var dvz = sin((this.pitch + pm) * (Math.PI / 180));

			this.transSpeed += (transOutLen / 600);
			var maxspd = (transOutLen / 200)
			if (this.transSpeed > maxspd) this.transSpeed = maxspd;

			this.transCounter += this.transSpeed;

			var cc = this.transCounter;

			//if (cc < 20) {
			if (cc < 20 || player.currentView.renderer.opacity < 1) {
				this.preview.position.x = (dvx * cc);
				this.preview.position.y = (dvy * cc);
				this.preview.position.z = (dvz * cc);
			} else {
				player.lastView = null;
			}
		}

	},

	reorient: function() {
		//sphereWebGLStatic.renderer.setSize( sphereWebGLStatic.node.width(), sphereWebGLStatic.node.height());
	},

	togglePhotoPreview: function() {
		if (!this.isPhotoPreview) {
			this.isPhotoPreview = true;
			this.originWidth = sphereWebGLStatic.node.width();
			this.originHeight = sphereWebGLStatic.node.height();

			sphereWebGLStatic.node.width("2000px");
			sphereWebGLStatic.node.height("1000px");
			sphereWebGLStatic.renderer.setSize(2000, 1000);

			var sx = this.originWidth / 2000;
			var sy = sx;//oldh / 1000;

			sphereWebGLStatic.node.css("transform-origin", "0 40%");
			sphereWebGLStatic.node.css("transform", "scale(" + sx + ", " + sy +")");

			setTimeout(function() {
				sphereWebGLStatic.self.setPerspective(sphereWebGLStatic.self.zoom, 2000 / sphereWebGLStatic.self.originWidth);
			}, 100);
			//self.setPerspective(self.zoom);
		} else if (this.isPhotoPreview) {
			this.isPhotoPreview = false;
			sphereWebGLStatic.node.width(this.originWidth);
			sphereWebGLStatic.node.height(this.originHeight);
			sphereWebGLStatic.renderer.setSize(this.originWidth, this.originHeight);

			sphereWebGLStatic.node.css("transform-origin", "");
			sphereWebGLStatic.node.css("transform", "");

			//self.setPerspective(self.zoom);			
			setTimeout(function() {
				sphereWebGLStatic.self.setPerspective(sphereWebGLStatic.self.zoom);
			}, 100);
		}
	},

	screenshot: function(promise) {
		var imgdata;
		var oldw = sphereWebGLStatic.node.width();
		var oldh = sphereWebGLStatic.node.height();

		var self = this;
		/*
		if (this.scprv == undefined) {
			this.scprv = $("<img>");
			this.scprv.css("position", "absolute");
			this.scprv.css("left", "50px");
			this.scprv.css("top", "50px");
			this.scprv.css("width", "400px");
			//this.scprv.css("height", "200px");
			$("#panels").append(this.scprv);
		}
		*/

		/*
		sphereWebGLStatic.node.width(2000);
		sphereWebGLStatic.node.height(1000);
		
		sphereWebGLStatic.renderer.setSize(2000, 1000);
		self.setPerspective(self.zoom);
		*/

		setTimeout(function() {

			imgdata = self.renderer.domElement.toDataURL("image/jpeg");
			//self.scprv.attr("src", imgdata);
			
//			setTimeout(function() {
			
				/*		
				sphereWebGLStatic.node.width("100%");
				sphereWebGLStatic.node.height("100%");
				sphereWebGLStatic.renderer.setSize(oldw, oldh);
				self.setPerspective(self.zoom);
				*/

//			}, 500);

			promise(imgdata);

		}, 100);

	}
}